import React from 'react';
import { Link, useLocation } from "react-router";

const NotFound: React.FC = () => {
    const { message } = useLocation().state;

    return (
        <div>
            <div className="text-center text-5xl font-thin mt-6">
                <h1>Whoops this page couldn't be found 🙈</h1>
            </div>
            <div className="text-center text-xl mt-12 bg-br-blue-300 py-5">
                <p>
                    { message }
                </p>
                <p className="pt-3">
                    <Link to={`/`}><i className="fad fa-home-heart" /> Go to the homepage</Link>
                </p>
            </div>
        </div>
    );
}

export default NotFound;